import apiClient from "@/app/api/client";

export const statsService = {
	dashboard(params?: { period?: string }) {
		return apiClient.get("/stats/dashboard", { params }).then((r) => r.data);
	},
	events(params?: Record<string, unknown>) {
		return apiClient.get("/stats/events", { params }).then((r) => r.data);
	},
	devices() {
		return apiClient.get("/stats/devices").then((r) => r.data);
	},
};
